import { StateCreator } from "zustand/esm";
import { PersonnelsStore } from "@/services/stores/types";

export const personnelsStore: StateCreator<PersonnelsStore> = set => ({
  personnels: null,
  setPersonnels: personnels => set(() => ({ personnels })),
  resetPersonnels: () =>
    set(() => ({ personnels: null, selectedPersonnelMode: null })),
  selectedPersonnelMode: null,
  setSelectedPersonnelMode: selectedPersonnelMode =>
    set(() => ({ selectedPersonnelMode })),
});
